import script from "./ChargeTemplateTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChargeTemplateTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__